import {session} from './storage'

export const tokenKey = (process.env.BUILD_ENV === 'prod' || process.env.VUE_APP_BUILD_ENV === 'prod') 
  ? 'iopTokenWap' 
  : 'iopTokenWapDev';
export const domain = process.env.BUILD_ENV === 'dev' ? '' : '.quanyou.com.cn';

export function getToken() {
  return session.get(tokenKey) || '';
}

export function setToken(token) {
  session.set(tokenKey, token);
}

export function removeToken() {
  session.remove(tokenKey);
}